<template lang="pug">
.a-card.mentor-comments.is-only-mentor
  .card-list.a-card
    mentorComment(
      v-for='(mentorComment,index) in mentorComments'
      :key='mentorComment.id',
      :mentorComment='mentorComment',
      :currentUser='currentUser',
      :id='"mentor_comment_" + mentorComment.id',
      :isLatest='index === mentorComments.length - 1',
      @delete='deleteMentorComment',
      @update='updateMentorComment',
    )
  .a-form-tabs.js-tabs
    .a-form-tabs__tab.js-tabs__tab(
      :class='{ "is-active": isActive("mentor-comment") }',
      @click='changeActiveTab("mentor-comment")')
      | コメント
    .a-form-tabs__tab.js-tabs__tab(
      :class='{ "is-active": isActive("preview") }',
      @click='changeActiveTab("preview")')
      | プレビュー
  .a-markdown-input.js-markdown-parent
    .a-markdown-input__inner.js-tabs__content(
      :class='{ "is-active": isActive("mentor-comment") }')
      .form-textarea
        .form-textarea__body
          textarea#js-new-mentor-comment.a-text-input.js-warning-form.a-markdown-input__textarea(
            v-model='body',
            ref='newMentorComment',
            name='new_mentor_comment[body]',
            data-preview='#new-mentor-comment-preview',
            data-input='.new-mentor-comment-file-input',
            @input='editMentorComment')
        .form-textarea__footer
          .form-textarea__insert
            label.a-file-insert.a-button.is-xs.is-text-reversal.is-block
              | ファイルを挿入
              input.new-mentor-comment-file-input(type='file', multiple)
    .a-markdown-input__inner.js-tabs__content(
      :class='{ "is-active": isActive("preview") }')
      #new-mentor-comment-preview.a-long-text.is-md.a-markdown-input__preview
  .card-footer
    .card-main-actions
      .card-main-actions__items
        .card-main-actions__item
          button#js-shortcut-post-comment.a-button.is-sm.is-primary.is-block(
            @click='postMentorComment',
            :disabled='!validation || buttonDisabled')
            | コメント
</template>
<script>
import CSRF from 'csrf'
import MentorComment from 'mentor-comment.vue'
import TextareaInitializer from 'textarea-initializer'
import toast from 'toast'
import role from 'role'

export default {
  components: {
    mentorComment: MentorComment,
  },
  mixins: [toast, role],
  props: {
    mentorCommentableId: { type: String, required: true },
    mentorCommentableType: { type: String, required: true },
    currentUserId: { type: Number, required: true },
    currentUser: { type: Object, required: true }
  },
  data() {
    return {
      mentorComments: [],
      body: '',
      tab: 'mentor-comment',
      buttonDisabled: false,
      defaultTextareaSize: null,
      loaded: false,
      editing: false,
    }
  },
  computed: {
    validation() {
      return this.body.length > 0
    }
  },
  created() {
    this.showComments()
  },
  methods: {
    isActive(tab) {
      return this.tab === tab
    },
    changeActiveTab(tab) {
      this.tab = tab
    },
    showComments() {
      fetch(
        `/api/mentor_comments.json?mentor_commentable_type=${this.mentorCommentableType}&` +`mentor_commentable_id=${this.mentorCommentableId}`,
        {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          redirect: 'manual'
        }
      )
        .then((response) => {
          return response.json()
        })
        .then((json) => {
          json.mentor_comments.forEach((c) => {
            this.mentorComments.unshift(c)
          })
        })
        .catch((error) => {
          console.warn(error)
        })
        .finally(() => {
          if (this.loaded === false) {
            this.loaded = true
            this.$nextTick(() => {
              TextareaInitializer.initialize('#js-new-mentor-comment')
              this.setDefaultTextareaSize()
              Prism.highlightAll()
            })
          }
        })
    },
    createMentorComment({ toastMessage } = {}) {
      if (this.body.length < 1) {
        return null
      }
      this.buttonDisabled = true
      this.editing = false
      const params = {
        mentor_comment: { body: this.body },
        mentor_commentable_type: this.mentorCommentableType,
        mentor_commentable_id: this.mentorCommentableId
      }
      fetch(`/api/mentor_comments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': CSRF.getToken()
        },
        credentials: 'same-origin',
        redirect: 'manual',
        body: JSON.stringify(params)
      })
        .then((response) => {
          return response.json()
        })
        .then(async (mentor_comment) => {
          this.mentorComments.push(mentor_comment)
          this.body = ''
          this.clearPreview('new-mentor-comment-preview')
          this.tab = 'mentor-comment'
          this.buttonDisabled = false
          this.resizeTextarea()
          this.displayToast(toastMessage)
          this.$nextTick(() =>{
            const cardList = document.querySelector('.card-list.a-card')
            cardList.scrollTop = cardList.scrollHeight
          })
        })
        .catch((error) => {
          console.warn(error)
        })
        .finally(() => {
          Prism.highlightAll()
        })
    },
    deleteMentorComment(id) {
      fetch(`/api/mentor_comments/${id}.json`, {
        method: 'DELETE',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': CSRF.getToken()
        },
        credentials: 'same-origin',
        redirect: 'manual'
      })
        .then(() => {
          this.mentorComments.forEach((mentor_comment, i) => {
            if (mentor_comment.id === id) {
              this.mentorComments.splice(i, 1)
            }
          })
          this.displayToast('コメントを削除しました！')
        })
        .catch((error) => {
          console.warn(error)
        })
    },
    updateMentorComment(body, id) {
      const updatedComment = this.mentorComments.find((comment) => {
        return comment.id === id
      })
      updatedComment.body = body
      this.displayToast('コメント更新しました！')
    },
    setDefaultTextareaSize() {
      const textarea = document.getElementById('js-new-mentor-comment')
      this.defaultTextareaSize = textarea.scrollHeight
    },
    resizeTextarea() {
      const textarea = document.getElementById('js-new-mentor-comment')
      textarea.style.height = `${this.defaultTextareaSize}px`
    },
    postMentorComment() {
      this.createMentorComment()
    },
    editMentorComment() {
      if (this.body.length > 0) {
        this.editing = true
      }

      this.$nextTick(() => {
        Prism.highlightAll()
      })
    },
    clearPreview(elementId) {
      const parent = document.getElementById(elementId)
      while (parent.lastChild) {
        parent.removeChild(parent.lastChild)
      }
    }
  }
}
</script>